import React from 'react';
import './LegalStyles.css';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1 className="legal-title">奇迹妙审 - 服务条款</h1>
        <p className="legal-date">最后更新日期: {new Date().toISOString().split('T')[0]}</p>
        
        <div className="legal-section">
          <h2>1. 接受条款</h2>
          <p>欢迎使用奇迹妙审服务（以下简称"服务"）。请仔细阅读以下条款和条件。通过访问或使用我们的服务，您同意受这些条款的约束。如果您不同意这些条款的任何部分，请勿使用我们的服务。</p>
        </div>
        
        <div className="legal-section">
          <h2>2. 服务说明</h2>
          <p>奇迹妙审是一个提供AI内容审核与管理的平台，旨在帮助用户管理、优化和保护其线上内容。我们提供的具体功能和服务可能会随时间而变化，我们保留修改、暂停或终止服务的权利，恕不另行通知。</p>
        </div>
        
        <div className="legal-section">
          <h2>3. 用户注册和账户</h2>
          <p>3.1 注册要求：使用我们的部分服务需要创建账户。您同意提供准确、完整和最新的注册信息。</p>
          <p>3.2 账户安全：您负责维护您的账户密码的机密性，并且您同意对在您的账户下发生的所有活动负全部责任。</p>
          <p>3.3 未经授权使用：如果您发现任何未经授权使用您的账户的情况，您同意立即通知我们。</p>
        </div>
        
        <div className="legal-section">
          <h2>4. 服务使用</h2>
          <p>4.1 合法使用：您同意仅将我们的服务用于合法目的，并且不会违反任何适用的法律法规。</p>
          <p>4.2 禁止行为：您不得：</p>
          <ul>
            <li>使用我们的服务进行任何非法活动</li>
            <li>上传、分享或处理任何侵犯第三方权利的内容</li>
            <li>尝试干扰或破坏服务的正常运行</li>
            <li>规避、禁用或以其他方式干扰服务的安全相关功能</li>
            <li>使用自动化程序、机器人或爬虫等方式访问服务，除非经我们明确许可</li>
          </ul>
          <p>4.3 使用限制：我们可能对服务的某些功能或部分设置限制，例如使用频率、存储容量等。我们保留随时修改这些限制的权利。</p>
        </div>
        
        <div className="legal-section">
          <h2>5. 用户内容</h2>
          <p>5.1 用户所有权：对于您上传、提交或以其他方式通过我们的服务提供的内容（以下简称"用户内容"），您保留所有权利。</p>
          <p>5.2 授权：您授予我们全球性、非独家、免版税的许可，允许我们使用、复制、修改、创建衍生作品、分发、公开展示和执行用户内容，仅用于提供和改进我们的服务。</p>
          <p>5.3 内容责任：您对您的用户内容负全部责任，并保证您拥有必要的权利来授予上述许可。</p>
        </div>
        
        <div className="legal-section">
          <h2>6. 知识产权</h2>
          <p>6.1 我们的内容：服务中的所有内容、功能和特性，包括但不限于文本、图形、徽标、图标、图像、音频剪辑、下载、界面和代码，均为我们或我们的许可人的财产，受版权、商标、专利和其他知识产权法保护。</p>
          <p>6.2 使用限制：未经我们的明确书面许可，您不得复制、修改、创建衍生作品、公开展示、再版、下载、存储或传输服务中的任何材料。</p>
        </div>
        
        <div className="legal-section">
          <h2>7. 订阅和支付</h2>
          <p>7.1 收费服务：我们的部分服务可能需要付费。所有价格均以人民币计价，并包含适用的税费。</p>
          <p>7.2 付款条件：您同意支付所有费用，并授权我们向您指定的支付方式收取费用。</p>
          <p>7.3 订阅续订：除非您在续订日期前取消，否则所有订阅将自动续订。</p>
          <p>7.4 退款政策：除非适用法律要求，否则我们不提供退款。</p>
        </div>
        
        <div className="legal-section">
          <h2>8. 免责声明</h2>
          <p>8.1 服务"按原样"提供：我们的服务"按原样"和"按可用性"提供，不作任何形式的明示或暗示保证。</p>
          <p>8.2 责任限制：在法律允许的最大范围内，我们对因使用或无法使用我们的服务而导致的直接、间接、偶然、特殊、惩罚性或后果性损害不承担责任。</p>
        </div>
        
        <div className="legal-section">
          <h2>9. 服务变更和终止</h2>
          <p>9.1 服务变更：我们可能随时修改、暂停或终止我们的任何服务，恕不另行通知。</p>
          <p>9.2 账户终止：我们保留出于任何原因或无任何原因随时终止或暂停您的账户和访问权限的权利，恕不另行通知。</p>
        </div>
        
        <div className="legal-section">
          <h2>10. 条款修改</h2>
          <p>我们可能会不时修改这些条款。当我们进行重大更改时，我们将通过适当的方式通知您，例如在我们的网站上发布通知或发送电子邮件。您继续使用我们的服务将构成您对修改后的条款的接受。</p>
        </div>
        
        <div className="legal-section">
          <h2>11. 法律适用和争议解决</h2>
          <p>11.1 法律适用：这些条款受中华人民共和国法律管辖。</p>
          <p>11.2 争议解决：与这些条款相关的任何争议应首先通过友好协商解决。如果协商不成，应提交至我们主要营业地所在地的有管辖权的法院解决。</p>
        </div>
        
        <div className="legal-section">
          <h2>12. 联系我们</h2>
          <p>如果您对这些条款有任何问题或疑虑，请通过以下方式联系我们：</p>
          <p>电子邮件：service@giant-ads.com</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 